import { action, observable } from "mobx";

import { loadSettings, saveSettings } from "./savedSettings";

const KEY = "bandstand.settings";

const DEFAULTS = { holdToArrange: true };

/** How the app behaves on this device, apart from how it looks. */
export class SettingsStore {
    /** Whether holding a chord on the sheet starts arranging. When it's off, only the Edit button does. */
    @observable accessor holdToArrange = DEFAULTS.holdToArrange;

    constructor() {
        Object.assign(this, loadSettings(KEY, DEFAULTS));
    }

    @action
    setHoldToArrange(hold: boolean): void {
        this.holdToArrange = hold;
        saveSettings(KEY, { holdToArrange: this.holdToArrange });
    }

    /** Takes settings from elsewhere, like the share server. */
    @action
    apply(saved: typeof DEFAULTS): void {
        this.setHoldToArrange(saved.holdToArrange);
    }
}
